import { GridColDef } from '@mui/x-data-grid-pro'
import { useTranslation } from 'react-i18next'
import styles from '../DashboardColumns.module.scss'
import ChipsCell from '@/shared/components/Table/components/ChipsCell/ChipsCell'

export const useSoldItemsQuantityColumnsConfig = () => {
  const { t } = useTranslation()
  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'ID',
      resizable: false,
      width: 44,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      sortable: false,
      hideSortIcons: true,
      disableColumnMenu: true,
      hideable: false,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
    {
      field: 'name',
      headerName: t('TABLE.MENU.HEADERS.NAME'),
      flex: 1,
      editable: false,

      hideable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 80,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
    {
      field: 'quantity',
      headerName: t('TABLE.MENU.HEADERS.QUANTITY'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 80,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    },
    {
      field: 'orderedWith',
      headerName: t('TABLE.MENU.HEADERS.ORDERED_WITH'),
      flex: 1,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 128,
      sortable: false,
      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      ),
      renderCell: params => <ChipsCell chipPayload={params.value} />
    },
    {
      field: 'percentage',
      headerName: t('TABLE.MENU.HEADERS.PERCENTAGE'),
      flex: 1,
      // Last column in the table, and it flexes to fill whatever the ones
      // before it leave. Dragging its edge only ever fought that.
      resizable: false,
      editable: false,
      headerClassName: `${styles.tableHeader}`,
      cellClassName: styles.tableCell,
      disableColumnMenu: true,
      minWidth: 128,

      renderHeader: params => (
        <p className={`${styles.tableHeaderText} body-bold-medium`}>
          {params.colDef.headerName}
        </p>
      )
    }
  ]
  return columns as GridColDef[]
}
